import { requestGet, requestPost, requestPut, requestDelete } from "../config/Api";

const name = "clients";

export function getClients(params = {}) {
  return requestGet(`/${name}`, { params });
}

export function getClient(id) {
  return requestGet(`/${name}/${id}`);
}

export function createClient(data) {
  return requestPost(`/${name}`, data);
}

export function updateClient(id, data) {
  return requestPut(`/${name}/${id}`, data);
}

export function deleteClient(id) {
  return requestDelete(`/${name}/${id}`);
}

export function getClientLegalFiles(clientId, params = {}) {
  return requestGet(`/${name}/${clientId}/legal/files`, { params });
}

export function searchAvailableParties(params = {}) {
  return requestGet(`/${name}/search/parties`, { params });
}

export function searchClients(params = {}) {
  return requestGet(`/${name}/search/simple`, { params });
}

export function attachPartyToClient(clientId, partyId) {
  return requestPost(`/${name}/${clientId}/parties`, { party_id: partyId });
}

export function detachPartyFromClient(clientId, partyId) {
  return requestDelete(`/${name}/${clientId}/parties/${partyId}`);
}
